import React from 'react';
import styled from 'styled-components';

import { LinkButton } from '@ui/buttons/Button.tsx';
import Icon from '@ui/icons/Icon.tsx';

import { useCSSColors } from '../../../../../src/hooks/useCSSColors.ts';

const Text = styled.span`
  line-height: normal;
  margin-top: -3px;
`;

const Wrapper = styled.div`
  display: flex;
  margin: 12px 0;

  ${LinkButton} {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: start;
    height: 52px;
    padding: 0 5px;

    &:only-of-type {
      padding: 10px 5px;
      flex-direction: row;
      justify-content: center;

      ${Text} {
        margin-top: 0;
      }
    }
  }
`;

const Spacing = styled.div`
  &:not(:last-of-type) {
    padding-inline-end: 12px;
  }
`;

const CTAButtons = ({ poi, T, submitAnalyticsEvent }) => {
  const colors = useCSSColors();
  // Here is a mapping of link types that will result in buttons
  // TODO: remove grab link type and related code once grab plugin is fully migrated to use mobileordering link type
  const ctas = {
    menu: { title: T('poiView:Menu'), icon: 'menu' },
    shop: { title: T('poiView:Shop Now'), icon: 'shop' },
    mobileordering: { title: T('poiView:Order/Pay Online'), icon: 'servy' },
    grab: { title: T('poiView:Order/Pay Online'), icon: 'servy' },
  };

  const Button = ({ url, text, iconId, onClick, dataTestId }) => (
    <React.Fragment>
      <LinkButton
        data-testid={dataTestId}
        href={url}
        target="_blank"
        backgroundColor={colors.secondaryButton}
        hoverBackgroundColor={colors.secondaryButtonHover}
        fontColor={colors.secondaryButtonText}
        onClick={onClick}
      >
        <Icon iconSize="md" name={iconId} fillColor={colors.secondaryButtonText} />
        <Text>{text}</Text>
      </LinkButton>
      <Spacing />
    </React.Fragment>
  );

  const buttons =
    poi.links &&
    poi.links
      .map(link => {
        const cta = ctas[link.type];
        return cta ? (
          <Button
            key={`cta-button-${link.type}`}
            dataTestId={`cta-button-${link.type}`}
            url={link.url}
            text={cta.title}
            iconId={cta.icon}
            onClick={() => submitAnalyticsEvent(poi, link.type, link.url)}
          />
        ) : null;
      })
      .filter(x => x); // strip nulls

  return Boolean(buttons && buttons.length) && <Wrapper data-testid="CTAButtons">{buttons}</Wrapper>;
};

export default CTAButtons;
